import React, { FC } from 'react';

import { Box, Stack } from '@chakra-ui/react';

export const RegionsForDataPolicyManagement: FC = () => {
  return (
    <Stack spacing={4}>
      <Box>
        Some data sources, such as AWS S3, use region-based configurations for
        the purpose of controlling access to sensitive data for IAM principals
        and federated users and groups.
      </Box>
      <Box>
        For access management and control, Ariksa allows users to control
        specific paths for buckets on a regional basis. If you expect to only
        use the existing regions for storing data and not expand to new regions,
        you can choose to enable data access policies only to those regions. On
        the other hand. If you expect to expand the use of regions, you can
        choose to set up access control in all regions.
      </Box>
    </Stack>
  );
};
